import { useEffect, useState, useCallback } from 'react'
import { Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import bus from 'api/snackbar'

export default function GlobalSnackbarHost() {
  const [open, setOpen] = useState(false)
  const [state, setState] = useState({
    message: '',
    severity: 'warning',
    autoHideDuration: 4000
  })

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return
    setOpen(false)
  }

  const show = useCallback((message, opts = {}) => {
    setState((prev) => ({
      ...prev,
      message: String(message || ''),
      severity: opts.severity || 'warning',
      autoHideDuration: Number(opts.autoHideDuration ?? 4000)
    }))
    setOpen(true)
  }, [])

  useEffect(() => {
    bus.setHandler(show)
  }, [show])

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={state.autoHideDuration}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        onClose={handleClose}
        severity={state.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {state.message}
      </Alert>
    </Snackbar>
  )
}
